module.exports = __webpack_public_path__ + "static/media/2.68487cb1.jpg";